import * as React from 'react';

import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { Typography } from 'omakase';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      alignItems: 'flex-end',
      display: 'flex',
      flexWrap: 'wrap',
    },
    titleRow: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(2),
    },
    subtitle: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'block',
      },
    },
    subTitleSection: {
      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(1),
      },
    },
    subTitleSubSection: {
      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
      },
    },
  })
);

interface Props {
  isTitle: boolean;
  subtitle?: string;
  title: string;
  variant?: 'subsection' | 'default';
  arrowLink?: JSX.Element;
}

export const CardSectionTitle: React.FunctionComponent<Props> = ({
  isTitle,
  subtitle,
  title,
  variant = 'default',
  arrowLink,
}) => {
  const classes = useStyles();
  const isSubSection = variant === 'subsection';
  return (
    <section>
      <Typography
        component={isTitle ? 'h1' : 'h2'}
        className={
          subtitle
            ? isSubSection
              ? classes.subTitleSubSection
              : classes.subTitleSection
            : undefined
        }
        variant={isSubSection ? 'heading03' : 'heading02'}
        data-testid={`title-${title.replace(/\W/g, '').toLowerCase()}`}
      >
        {title}
      </Typography>

      <div className={classes.titleRow}>
        {subtitle && (
          <Typography className={classes.subtitle} color="fgDefault" variant="body01" component="p">
            {subtitle}
          </Typography>
        )}
        {subtitle && arrowLink}
      </div>
    </section>
  );
};
